module.exports = __webpack_public_path__ + "img/vs.cf48967d.png";